

































































































































import { PaginatedList } from "@/api/models/common/paginatedList";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import {
  BButton,
  BCard,
  BCol,
  BDropdown,
  BFormSelect,
  BDropdownItem,
  BFormInput,
  BFormCheckbox,
  BPagination,
  BRow,
  BTable,
  BBadge,
  BAlert,
  BFormDatepicker,
  BFormGroup,
  BSpinner
} from "bootstrap-vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import { PtfBeneficiaireIntervenant } from "@/api/models/ptfBeneficiaire/Intervenant";

@Component({
  components: {
    BCard,
    BAlert,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BFormCheckbox,
    BTable,
    BPagination,
    BDropdown,
    BDropdownItem,
    BFormSelect,
    BBadge,
    SearchableVueSelect,
    BFormDatepicker,
    BFormGroup,
    BSpinner
  },
})
export default class ListIntervenants extends Vue {
  perPage = 10;
  currentPage = 1;
  perPageOptions = [2, 5, 10, 25, 50, 100];
  timeout: any = null;
  searchQuery = "";
  isLoading = false;
//   isSortDirDesc = false;
//   sortBy = "libelle";
 
  tableColumns = [
    { key: "nom", label: "Nom", sortable: false },
    { key: "prenom", label: "Prénom", sortable: false },
    { key: "telephone", label: "Téléphone", sortable: false },
    { key: "entrepriseLibelle", label: "Entreprise", sortable: false },
    // { key: "mission", sortable: false },
  ];
  paginatedListIntervenants = new PaginatedList<PtfBeneficiaireIntervenant>();

  async created() {
    await this.loadListIntervenants({
      pageNumber: this.currentPage,
      pageSize: this.perPage,
      search: this.searchQuery,
    });
  }

  get paginationFrom() {
    return (
      this.perPage * (this.currentPage - 1) +
      (this.paginatedListIntervenants.items.length ? 1 : 0)
    );
  }
  get paginationTo() {
    return (
      this.perPage * (this.currentPage - 1) +
      this.paginatedListIntervenants.items.length
    );
  }

  @Watch("currentPage")
  @Watch("perPage")
  async paginationChanged() {
    await this.loadListIntervenants({
      pageNumber: this.currentPage,
      pageSize: this.perPage,
      search: this.searchQuery
    });
  }

  @Watch('searchQuery')
//   @Watch("sortBy")
//   @Watch("isSortDirDesc")
  async searchAdherent() {
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await this.loadListIntervenants({
        pageNumber: this.currentPage,
        pageSize: this.perPage,
        // orderBy: this.sortBy,
        // orderByDescending: this.isSortDirDesc,
        search: this.searchQuery,
      })
    }, 1000);
  }

//   updateSort(params: any) {
//     this.sortBy = params.sortBy;
//     params = {
//       pageNumber: this.currentPage,
//       pageSize: this.perPage,
//       orderBy: this.sortBy,
//       orderByDescending: this.isSortDirDesc,
//       pertinentOnly: this.pertinentOnly,
//       sortStatuts: this.sortStatuts
//     };
//     this.isSortDirDesc = !this.isSortDirDesc;
//     this.loadListIntervenants(params);
//   }

  async loadListIntervenants(params: any) {
    this.isLoading = true;
    
    if (!params || params?.reset) {
      this.paginatedListIntervenants = new PaginatedList<PtfBeneficiaireIntervenant>();
    }

    await this.$http.ptfBeneficiaire.meetings
      .listIntervenants(
        params?.pageNumber ?? 1,
        params?.pageSize ?? 10,
        // params?.orderBy,
        // params?.orderByDescending,
        params?.search ?? ""
      )
      .then((response: PaginatedList<PtfBeneficiaireIntervenant>) => {
        this.paginatedListIntervenants = response;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  onRowSelected(record: any) {
    this.$router.push({ name: "manage-meetings-intervenant", params: { id: record.id } });
  }

}
